import { useEffect, useState, Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Beneficios from "./components/Beneficios";
import ComoFunciona from "./components/ComoFunciona";
import Categorias from "./components/Categorias";
import ParaSindicos from "./components/ParaSindicos";
import Galeria from "./components/Galeria";
import Sobre from "./components/Sobre";
import Novidades from "./components/Novidades";
import Faq from "./components/Faq";
import FormSolicitacao from "./components/FormSolicitacao";
import Footer from "./components/Footer";
import Admin from "./components/Admin";
import Corporativo from "./components/Corporativo";
import { WaIcon } from "./components/Logo";
import { waOpen, DEFAULT_MSG, BACKEND_URL } from "./lib/site";
import { ContentContext, mergeContent } from "./lib/content";
import "./App.css";

const GRAIN =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E\")";

function App() {
    const [content, setContent] = useState(() => mergeContent());

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        fetch(`${BACKEND_URL}/api/content`)
            .then((r) => r.json())
            .then((d) => {
                if (d && typeof d === "object" && Object.keys(d).length) {
                    const m = mergeContent(d);
                    setContent(m);
                    window.__CONBOX_WA = m.whatsapp.number;
                }
            })
            .catch(() => {});
    }, []);

    return (
        <ContentContext.Provider value={content}>
            <BrowserRouter>
                <ErrorBoundary>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </ErrorBoundary>
            </BrowserRouter>
        </ContentContext.Provider>
    );
}

function Home() {
    return (
        <div className="min-h-screen bg-[#F7F4EC] text-[#1A231E] antialiased">
            <div
                aria-hidden="true"
                className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-multiply"
                style={{ backgroundImage: GRAIN }}
            />

            <Navbar />

            <main>
                <Hero />
                <Marquee />
                <Beneficios />
                <ComoFunciona />
                <Categorias />
                <ParaSindicos />
                <Corporativo />
                <Galeria />
                <Sobre />
                <Novidades />
                <Faq />
                <FormSolicitacao />
            </main>

            <Footer />

            <button
                data-testid="whatsapp-fab"
                onClick={() => waOpen(DEFAULT_MSG)}
                aria-label="Falar no WhatsApp"
                className="fixed bottom-5 right-5 z-[65] w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1FB457] text-white grid place-items-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-all duration-200 hover:-translate-y-1 hover:scale-105"
            >
                <WaIcon className="w-7 h-7" />
            </button>
        </div>
    );
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-[#073A22] text-[#F7F4EC] grid place-items-center p-8 text-center">
                    <div>
                        <p className="text-2xl font-extrabold">Ops! Algo saiu do trilho.</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="mt-4 rounded-full bg-[#F57A3A] px-6 py-3 font-bold"
                        >
                            Recarregar
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default App;
